import { render } from "./LastModifiedRow.vue?vue&type=template&id=2c63a99e"
import script from "./LastModifiedRow.vue?vue&type=script&lang=js"
export * from "./LastModifiedRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__